import "core-js/modules/es6.function.name";
export var mixin = {
  methods: {
    decideRoute: function decideRoute() {
      //组织机构
      if (this.$route.name == 'treeDeptList/treeDeptDetails') {
        return {
          show: true,
          title: '单位管理'
        };
      }
      if (this.$route.name == 'deptList/deptDetails') {
        return {
          show: true,
          title: '部门管理'
        };
      }
      if (this.$route.name == 'employeeList/employeeDetails') {
        return {
          show: true,
          title: '员工管理'
        };
      }
      if (this.$route.name == 'employeeDetails') {
        return {
          show: true,
          title: '员工详情'
        };
      }
      if (this.$route.name == 'messageInfo') {
        return {
          show: true,
          title: '消息通知'
        };
      }
      if (this.$route.name == 'messageDetails') {
        return {
          show: true,
          title: '消息通知详情'
        };
      }

      // alert(this.$route.name)
      if (this.$route.name == 'offlineRentOutRecord') {
        return {
          show: true,
          title: '线下租赁备案管理'
        };
      } else if (this.$route.name == 'vehicleAttendance') {
        return {
          show: true,
          title: '施工设备出勤统计表'
        };
      } else if (this.$route.name == 'carAttendance') {
        return {
          show: true,
          title: '车辆出勤统计表'
        };
      } else if (this.$route.name == 'ruleAdd') {
        return {
          show: true,
          title: '文件上传'
        };
      } else if (this.$route.name == 'ruleShare') {
        return {
          show: true,
          title: '股份制度'
        };
      } else if (this.$route.name == 'ruleCompany') {
        return {
          show: true,
          title: '公司制度'
        };
      } else if (this.$route.name == 'ruleBranch') {
        return {
          show: true,
          title: '分局制度'
        };
      } else if (this.$route.name == 'stateLinkVehicle') {
        return {
          show: true,
          title: '物联设备信号连接状态'
        };
      } else if (this.$route.name == 'stateLinkDetails') {
        return {
          show: true,
          title: '物联设备信号连接状态明细'
        };
      } else if (this.$route.name == 'fuleNoeVehicle') {
        return {
          show: true,
          title: '施工设备用油分析表'
        };
      } else if (this.$route.name == 'fuleNoeCar') {
        return {
          show: true,
          title: '单车辆用油分析表'
        };
      }

      //2023/11/13修改
      //物联设备台账管理
      else if (this.$route.name == 'vehiclePlatformCode') {
        return {
          show: true,
          title: '设备台帐编制'
        };
      } else if (this.$route.name == 'vehicleAccountFixSearchImport') {
        return {
          show: true,
          title: '导入设备台账'
        };
      } else if (this.$route.name == 'vehicleAccountFixSearch') {
        return {
          show: true,
          title: '设备台帐查询/维护'
        };
      } else if (this.$route.name == 'roleList') {
        return {
          show: true,
          title: '职务/岗位管理'
        };
      } else if (this.$route.name == 'auditEmpList') {
        return {
          show: true,
          title: '审批人员管理'
        };
      } else if (this.$route.name == 'roleListAdd') {
        return {
          show: true,
          title: '编制职务岗位'
        };
      } else if (this.$route.name == 'roleDetails') {
        return {
          show: true,
          title: '职务/岗位详情'
        };
      }
      //车辆基础管理
      else if (this.$route.name == 'carList') {
        return {
          show: true,
          title: '车辆档案'
        };
      } else if (this.$route.name == 'carAdd') {
        return {
          show: true,
          title: '手动编制'
        };
      } else if (this.$route.name == 'carAddSelf') {
        return {
          show: true,
          title: '自动导入'
        };
      } else if (this.$route.name == 'carDetails') {
        return {
          show: true,
          title: '车辆详情'
        };
      } else if (this.$route.name == 'carEdit') {
        return {
          show: true,
          title: '修改设备'
        };
      } else if (this.$route.name == 'driverList') {
        return {
          show: true,
          title: '司机档案'
        };
      } else if (this.$route.name == 'driverAdd') {
        return {
          show: true,
          title: '编制司机'
        };
      } else if (this.$route.name == 'driverDetails') {
        return {
          show: true,
          title: '司机详情'
        };
      } else if (this.$route.name == 'historyCarList') {
        return {
          show: true,
          title: '销户车辆'
        };
      } else if (this.$route.name == 'carMaintainList') {
        return {
          show: true,
          title: '年审管理'
        };
      } else if (this.$route.name == 'carMaintainDetails') {
        return {
          show: true,
          title: '详情'
        };
      } else if (this.$route.name == 'violationList') {
        return {
          show: true,
          title: '违章明细'
        };
      } else if (this.$route.name == 'violationDetails') {
        return {
          show: true,
          title: '车辆违章详情'
        };
      } else if (this.$route.name == 'dealViolation') {
        return {
          show: true,
          title: '处理明细'
        };
      } else if (this.$route.name == 'violationStat') {
        return {
          show: true,
          title: '车辆违章统计'
        };
      } else if (this.$route.name == 'carReport') {
        return {
          show: true,
          title: '车辆报表'
        };
      } else if (this.$route.name == 'carReportFormList') {
        return {
          show: true,
          title: '车辆档案报表'
        };
      } else if (this.$route.name == 'violationReportFormList') {
        return {
          show: true,
          title: '车辆违章报表'
        };
      } else if (this.$route.name == 'carMaintainReportFormList') {
        return {
          show: true,
          title: '车辆年审报表'
        };
      } else if (this.$route.name == 'historyCarDetails') {
        return {
          show: true,
          title: '销户详情'
        };
      } else if (this.$route.name == 'carMaintainReportFormDetails') {
        return {
          show: true,
          title: '车辆年审月度报表'
        };
      } else if (this.$route.name == 'entpAuditManage') {
        return {
          show: true,
          title: '回收单位资格审查'
        };
      } else if (this.$route.name == 'recoveryReport') {
        return {
          show: true,
          title: '报表管理'
        };
      }

      //租赁管理
      else if (this.$route.name == 'updateBidding') {
        return {
          show: true,
          title: '租赁管理'
        };
      } else if (this.$route.name == '项目申请审批') {
        return {
          show: true,
          title: '租赁管理'
        };
      } else if (this.$route.name == 'buildBidding') {
        return {
          show: true,
          title: '项目申请编制'
        };
      } else if (this.$route.name == 'reBuildBidding') {
        return {
          show: true,
          title: '项目申请编制'
        };
      } else if (this.$route.name == 'reviewList') {
        return {
          show: true,
          title: '项目评审定标'
        };
      } else if (this.$route.name == 'updateBiddingDetail') {
        return {
          show: true,
          title: '设备租赁申请文件详情'
        };
      } else if (this.$route.name == 'reviewListDetail') {
        return {
          show: true,
          title: '评审文件详情'
        };
      } else if (this.$route.name == 'flowDestroy') {
        return {
          show: true,
          title: '流标申请'
        };
      } else if (this.$route.name == 'contractsList') {
        return {
          show: true,
          title: '合同签订'
        };
      } else if (this.$route.name == 'contractsDetails') {
        return {
          show: true,
          title: '合同详情'
        };
      } else if (this.$route.name == 'contractReport') {
        return {
          show: true,
          title: '合同台账'
        };
      } else if (this.$route.name == 'contractList') {
        return {
          show: true,
          title: '合同列表'
        };
      } else if (this.$route.name == 'vehicleHandOverManage') {
        return {
          show: true,
          title: '设备进退场登记'
        };
      } else if (this.$route.name == 'vehicleHandOverManageAdd') {
        return {
          show: true,
          title: '编制租赁设备交接鉴定表'
        };
      } else if (this.$route.name == 'vehicleHandOverManageExitList') {
        return {
          show: true,
          title: '设备进退场管理'
        };
      } else if (this.$route.name == 'vehicleHandOverManageDetail') {
        return {
          show: true,
          title: '租赁设备进场签认表详情'
        };
      } else if (this.$route.name == 'vehicleHandOverManageUpdate') {
        return {
          show: true,
          title: '填写租赁设备进场签认表'
        };
      } else if (this.$route.name == 'vehicleHandOverManageList') {
        return {
          show: true,
          title: '设备进退场管理'
        };
      } else if (this.$route.name == 'settlementsTransactList') {
        return {
          show: true,
          title: '结算办理'
        };
      } else if (this.$route.name == 'settlementsInformationList') {
        return {
          show: true,
          title: '结算进度'
        };
      } else if (this.$route.name == 'bidArchiveList') {
        return {
          show: true,
          title: '归档编制'
        };
      } else if (this.$route.name == 'bidArchiveReviewList') {
        return {
          show: true,
          title: '归档审核'
        };
      } else if (this.$route.name == 'bidArchiveStatisticsList') {
        return {
          show: true,
          title: '归档统计'
        };
      } else if (this.$route.name == 'bidArchiveDetails') {
        return {
          show: true,
          title: '归档编制明细'
        };
      } else if (this.$route.name == 'bidArchiveReviewDetails') {
        return {
          show: true,
          title: '归档审核详情'
        };
      } else if (this.$route.name == 'bidArchiveUpdate') {
        return {
          show: true,
          title: '归档编制'
        };
      } else if (this.$route.name == 'vehicleCarRentAdd') {
        return {
          show: true,
          title: '外租车辆台帐编制'
        };
      } else if (this.$route.name == 'vehicleCarRentList') {
        return {
          show: true,
          title: '外租车辆台帐查询/维护'
        };
      } else if (this.$route.name == 'vehicleCarRentStatistics') {
        return {
          show: true,
          title: '外租车辆运转统计'
        };
      } else if (this.$route.name == 'examination') {
        return {
          show: true,
          title: '资格审查'
        };
      } else if (this.$route.name == 'examinationDetail') {
        return {
          show: true,
          title: '资格审查详情'
        };
      } else if (this.$route.name == 'supplier') {
        return {
          show: true,
          title: '合格出租商管理'
        };
      } else if (this.$route.name == 'supplierDetail') {
        return {
          show: true,
          title: '出租商详情'
        };
      } else if (this.$route.name == 'entpEvaluationsList') {
        return {
          show: true,
          title: '出租商动态评价'
        };
      } else if (this.$route.name == 'entpEvaluationsAdd') {
        return {
          show: true,
          title: '出租商动态评价表'
        };
      } else if (this.$route.name == 'entpEvaluationsDetail') {
        return {
          show: true,
          title: '出租商动态评价表详情'
        };
      } else if (this.$route.name == 'entpYearEvaluationsList') {
        return {
          show: true,
          title: '出租商年度评价'
        };
      } else if (this.$route.name == 'rentAppraisalList') {
        return {
          show: true,
          title: '设备/材料租赁后评价'
        };
      } else if (this.$route.name == 'rentAppraisalAdd') {
        return {
          show: true,
          title: '设备/材料租赁后评价表'
        };
      } else if (this.$route.name == 'rentAppraisalDetail') {
        return {
          show: true,
          title: '设备/材料租赁后评价表'
        };
      } else if (this.$route.name == 'offlineRentOutRecordAdd') {
        return {
          show: true,
          title: '修改线下租赁备案表'
        };
      } else if (this.$route.name == 'bidReport') {
        return {
          show: true,
          title: '设备/材料租赁报表'
        };
      } else if (this.$route.name == 'settlementsReport') {
        return {
          show: true,
          title: '设备租赁管理月/季度报表'
        };
      } else if (this.$route.name == 'settlementsReportAdd') {
        return {
          show: true,
          title: '编制设备租赁管理月/季度报表'
        };
      } else if (this.$route.name == 'settlementsSummary') {
        return {
          show: true,
          title: '设备租赁管理月/季度汇总表'
        };
      } else if (this.$route.name == 'saveReport') {
        return {
          show: true,
          title: '设备/材料租赁费用及节资率报表'
        };
      } else if (this.$route.name == 'rentReport') {
        return {
          show: true,
          title: '设备/材料租赁费用明细报表'
        };
      } else if (this.$route.name == 'rentPriceReport') {
        return {
          show: true,
          title: '设备/材料租赁费用明细分析表'
        };
      } else if (this.$route.name == 'rentAppraisalReport') {
        return {
          show: true,
          title: '设备/材料租赁后评价表'
        };
      } else if (this.$route.name == 'rentOutReport') {
        return {
          show: true,
          title: '设备/材料租入（租出）清查登记表'
        };
      } else if (this.$route.name == 'customReport') {
        return {
          show: true,
          title: '设备租赁自定义报表'
        };
      } else if (this.$route.name == 'wasteContractList') {
        return {
          show: true,
          title: '合同管理'
        };
      } else if (this.$route.name == 'recoveryContractUpdate') {
        return {
          show: true,
          title: '编制合同'
        };
      } else if (this.$route.name == 'recoverySettlementsList') {
        return {
          show: true,
          title: '结算办理'
        };
      } else if (this.$route.name == 'recoveryArchiveList') {
        return {
          show: true,
          title: '处置归档编制'
        };
      } else if (this.$route.name == 'recoveryArchiveAdd') {
        return {
          show: true,
          title: '处置归档编制'
        };
      } else if (this.$route.name == 'recoveryArchiveDetails') {
        return {
          show: true,
          title: '处置归档详情'
        };
      } else if (this.$route.name == 'recoveryArchiveReviewList') {
        return {
          show: true,
          title: '处置归档审核'
        };
      } else if (this.$route.name == 'recoveryArchiveReviewDetails') {
        return {
          show: true,
          title: '归档审核详情'
        };
      } else if (this.$route.name == 'recoveryArchiveStatisticsList') {
        return {
          show: true,
          title: '处置归档统计'
        };
      } else if (this.$route.name == 'entpAuditDetail') {
        return {
          show: true,
          title: '回收单位详情'
        };
      } else if (this.$route.name == 'entpLibraryManage') {
        return {
          show: true,
          title: '回收单位库管理'
        };
      } else if (this.$route.name == 'entpLibraryDetail') {
        return {
          show: true,
          title: '回收单位详情'
        };
      } else if (this.$route.name == 'recoveryOfflineRecord') {
        return {
          show: true,
          title: '线下处置备案管理'
        };
      } else if (this.$route.name == 'recoveryOfflineRecordAdd') {
        return {
          show: true,
          title: '修改线下处置备案表'
        };
      } else if (this.$route.name == 'recoveryAmountReport') {
        return {
          show: true,
          title: '废旧设备/物资处置金额报表'
        };
      } else if (this.$route.name == 'recoveryCustomReport') {
        return {
          show: true,
          title: '废旧处置自定义报表'
        };
      }
      //废旧处置管理
      else if (this.$route.name == 'auctionProclamationAdd') {
        return {
          show: true,
          title: '项目申请编制'
        };
      } else if (this.$route.name == 'wasteReviewList') {
        return {
          show: true,
          title: '项目申请审批'
        };
      } else if (this.$route.name == 'wasteRevieWDetail') {
        return {
          show: true,
          title: '项目申请审批详情'
        };
      } else if (this.$route.name == 'uploadRecoveryFile') {
        return {
          show: true,
          title: '项目申请编制'
        };
      } else if (this.$route.name == 'publicBiddingList') {
        return {
          show: true,
          title: '公开询比价'
        };
      } else if (this.$route.name == 'publicBiddingDetail') {
        return {
          show: true,
          title: '公开询比价详情'
        };
      } else if (this.$route.name == 'inviteBiddingList') {
        return {
          show: true,
          title: '邀请询比价'
        };
      } else if (this.$route.name == 'inviteBiddingDetail') {
        return {
          show: true,
          title: '公开询比价详情'
        };
      } else if (this.$route.name == 'auctionReviewList') {
        return {
          show: true,
          title: '公开竞拍'
        };
      } else if (this.$route.name == 'auctionReviewDetail') {
        return {
          show: true,
          title: '公开竞拍详情'
        };
      }
      // 施工设备物联管理
      if (this.$route.name == 'indexNoeVehicle') {
        return {
          show: true,
          title: '单施工设备出勤统计表'
        };
      }
      if (this.$route.name == 'indexNoeCar') {
        return {
          show: true,
          title: '单车车辆出勤统计表'
        };
      } else if (this.$route.name == 'oilAnalysisVehicle') {
        return {
          show: true,
          title: '施工设备用油分析表'
        };
      } else if (this.$route.name == 'oilAnalysisCar') {
        return {
          show: true,
          title: '车辆用油分析表'
        };
      } else if (this.$route.name == 'fuleCompareVehicle') {
        return {
          show: true,
          title: '施工设备加油量比对管理统计表'
        };
      } else if (this.$route.name == 'fuelVehicle') {
        return {
          show: true,
          title: '施工设备耗油/加油统计表'
        };
      } else if (this.$route.name == 'fuelCar') {
        return {
          show: true,
          title: '车辆耗油/加油统计表'
        };
      } else if (this.$route.name == 'equipmentOperation') {
        return {
          show: true,
          title: '设备运转统计'
        };
      } else if (this.$route.name == 'equipmentOperationDetail') {
        return {
          show: true,
          title: '设备运转详情'
        };
      } else if (this.$route.name == 'trajectoryMap') {
        return {
          show: true,
          title: '设备工况详情'
        };
      } else if (this.$route.name == 'signDetail') {
        return {
          show: true,
          title: '查看签认单'
        };
      } else if (this.$route.name == 'fuelDetail') {
        return {
          show: true,
          title: '查看加油记录'
        };
      } else if (this.$route.name == 'vehicleDistributionMap') {
        return {
          show: true,
          title: '设备分布地图'
        };
      } else if (this.$route.name == 'vehicleDistributionList') {
        return {
          show: true,
          title: '设备位置查询'
        };
      } else if (this.$route.name == 'traceReplay') {
        return {
          show: true,
          title: '设备工况查询'
        };
      } else if (this.$route.name == 'trackDetail') {
        return {
          show: true,
          title: '查看工况'
        };
      } else if (this.$route.name == 'electronicFence') {
        return {
          show: true,
          title: '设备电子围栏'
        };
      } else if (this.$route.name == 'electronicFenceAdd') {
        return {
          show: true,
          title: '编制电子围栏'
        };
      } else if (this.$route.name == 'electronicFenceDetail') {
        return {
          show: true,
          title: '电子围栏详情'
        };
      } else if (this.$route.name == 'exceptionRemind') {
        return {
          show: true,
          title: '设备状态异常提醒'
        };
      } else if (this.$route.name == 'fuelSignOffManageAdd') {
        return {
          show: true,
          title: '加油签认编制'
        };
      } else if (this.$route.name == 'exceptionRemindManage') {
        return {
          show: true,
          title: '设置状态异常提醒'
        };
      } else if (this.$route.name == 'exceptionRemindManageAdd') {
        return {
          show: true,
          title: '设置消息类型提醒'
        };
      } else if (this.$route.name == 'exceptionRemindManageDetail') {
        return {
          show: true,
          title: '设备异常提醒配置详情'
        };
      } else if (this.$route.name == 'fuelSignOffManageList') {
        return {
          show: true,
          title: '加油统计'
        };
      } else if (this.$route.name == 'fuelSignOffManageDetail') {
        return {
          show: true,
          title: '加油单详情'
        };
      } else if (this.$route.name == 'fuelSignOffManageUpdate') {
        return {
          show: true,
          title: '加油签认编制'
        };
      } else if (this.$route.name == 'vehicleAccountFixSearchEdit') {
        return {
          show: true,
          title: '修改设备'
        };
      } else if (this.$route.name == 'vehicleOperation') {
        return {
          show: true,
          title: '车辆运行管理'
        };
      } else if (this.$route.name == 'vehicleOperationDetail') {
        return {
          show: true,
          title: '车辆运转详情'
        };
      } else if (this.$route.name == 'vehicleOperationDetailMap') {
        return {
          show: true,
          title: '车辆轨迹详情'
        };
      } else if (this.$route.name == 'vehicleOperationDetailMapV2') {
        return {
          show: true,
          title: '设备轨迹详情'
        };
      } else if (this.$route.name == 'fuelCardRecordUpdate') {
        return {
          show: true,
          title: '油卡台账维护'
        };
      } else if (this.$route.name == 'fuelRecordUpdate') {
        return {
          show: true,
          title: '油卡台账维护编制'
        };
      } else if (this.$route.name == 'fuelCardManage') {
        return {
          show: true,
          title: '车辆油卡配置'
        };
      } else if (this.$route.name == 'fuelCardRecordAdd') {
        return {
          show: true,
          title: '油卡台账维护编制'
        };
      } else if (this.$route.name == 'fuelRecordDetails') {
        return {
          show: true,
          title: '车辆加油记录明细表'
        };
      } else if (this.$route.name == 'fuelRecordAdd') {
        return {
          show: true,
          title: '油卡台账维护编制'
        };
      } else if (this.$route.name == 'fuelRecordImport') {
        return {
          show: true,
          title: '导入加油记录表'
        };
      } else if (this.$route.name == 'fuelCardRecordManage') {
        return {
          show: true,
          title: '车辆使用油卡加油明细表'
        };
      } else if (this.$route.name == 'fuelConsumption') {
        return {
          show: true,
          title: '车辆油耗统计分析表'
        };
      } else if (this.$route.name == 'fuelUse') {
        return {
          show: true,
          title: '车辆油卡使用表'
        };
      } else if (this.$route.name == 'fuelCardRecordStatistics') {
        return {
          show: true,
          title: '车辆燃油使用分析表'
        };
      } else if (this.$route.name == 'fuelCardRecordDetails') {
        return {
          show: true,
          title: '车辆燃油使用明细表'
        };
      } else if (this.$route.name == 'fuelCardRecordDetailsMap') {
        return {
          show: true,
          title: '车辆轨迹详情'
        };
      } else if (this.$route.name == 'fuelVerifyAdd') {
        return {
          show: true,
          title: '项目级核销编制'
        };
      } else if (this.$route.name == 'fuelVerifyBranchAdd') {
        return {
          show: true,
          title: '分局级核销编制'
        };
      } else if (this.$route.name == 'fuelVerifyManage') {
        return {
          show: true,
          title: '核销审批'
        };
      } else if (this.$route.name == 'vehicleMap') {
        return {
          show: true,
          title: '车辆分布地图'
        };
      } else if (this.$route.name == 'vehicleLocation') {
        return {
          show: true,
          title: '车辆位置查询'
        };
      } else if (this.$route.name == 'vehicleTraceReplay') {
        return {
          show: true,
          title: '车辆轨迹查询'
        };
      } else if (this.$route.name == 'vehicleTraceDetail') {
        return {
          show: true,
          title: '查看轨迹'
        };
      } else if (this.$route.name == 'vehicleTrajectoryMap') {
        return {
          show: true,
          title: '车辆轨迹详情'
        };
      } else if (this.$route.name == 'vehicleElectronicFence') {
        return {
          show: true,
          title: '电子围栏管理'
        };
      } else if (this.$route.name == 'vehicleElectronicFenceAdd') {
        return {
          show: true,
          title: '编制电子围栏'
        };
      } else if (this.$route.name == 'vehicleElectronicFenceDetail') {
        return {
          show: true,
          title: '电子围栏详情'
        };
      } else if (this.$route.name == 'vehicleMessage') {
        return {
          show: true,
          title: '车辆监控信息提醒'
        };
      } else if (this.$route.name == 'carWaringConfigList') {
        return {
          show: true,
          title: '接收消息通知配置'
        };
      } else if (this.$route.name == 'carWaringConfigEdit') {
        return {
          show: true,
          title: '配置接收消息通知'
        };
      } else if (this.$route.name == 'carWaringConfigDetail') {
        return {
          show: true,
          title: '消息通知类型配置详情'
        };
      }

      // 租赁设备物联网终端安装统计
      else if (this.$route.name == 'vehicleIotList') {
        return {
          show: true,
          title: '租赁设备物联网管理'
        };
      } else if (this.$route.name == 'vehicleIotDetails') {
        return {
          show: true,
          title: '租赁设备物联网管理明细'
        };
      }
      // 物联网终端
      else if (this.$route.name == 'terminalList') {
        return {
          show: true,
          title: '物联网终端台账'
        };
      } else if (this.$route.name == 'terminalMessage') {
        return {
          show: true,
          title: '物联网终端使用信息'
        };
      }
      // 专家库管理
      else if (this.$route.name == 'experts') {
        return {
          show: true,
          title: '专家列表'
        };
      }
      // 闲置信息管理
      else if (this.$route.name == 'leaveDeviceListAdd') {
        return {
          show: true,
          title: '闲置施工设备编制'
        };
      } else if (this.$route.name == 'leaveDeviceListMaintain') {
        return {
          show: true,
          title: '设备闲置信息台账表'
        };
      } else if (this.$route.name == 'leaveMaterialListAdd') {
        return {
          show: true,
          title: '材料闲置信息编制'
        };
      } else if (this.$route.name == 'leaveDeviceListDelete') {
        return {
          show: true,
          title: '设备闲置失效信息统计表'
        };
      } else if (this.$route.name == 'leaveMaterialListMaintain') {
        return {
          show: true,
          title: '材料闲置信息台账'
        };
      } else if (this.$route.name == 'leaveMaterialListDelete') {
        return {
          show: true,
          title: '材料闲置失效信息统计表'
        };
      }
      //市场行情信息
      else if (this.$route.name == 'bidMarketList') {
        return {
          show: true,
          title: '设备/材料租赁行情'
        };
      } else if (this.$route.name == 'recoveryMarketList') {
        return {
          show: true,
          title: '废旧设备/物资处置行情'
        };
      } else if (this.$route.name == 'systemServiceReportManage') {
        return {
          show: true,
          title: '系统服务报告'
        };
      }
      //零采管理
      else if (this.$route.name == 'demandPlanEdit') {
        return {
          show: true,
          title: '需求计划编制'
        };
      } else if (this.$route.name == 'demandPlanList') {
        return {
          show: true,
          title: '计划审批统计'
        };
      } else if (this.$route.name == 'demandPlanDetail') {
        return {
          show: true,
          title: '物资需求计划详情'
        };
      } else if (this.$route.name == 'materialBidPlanEdit') {
        return {
          show: true,
          title: '采购计划编制'
        };
      } else if (this.$route.name == 'materialBidPlanDetail') {
        return {
          show: true,
          title: '计划审批详情'
        };
      } else if (this.$route.name == 'materialBidPlanList') {
        return {
          show: true,
          title: '计划审批统计'
        };
      } else if (this.$route.name == 'materialBidAdd') {
        return {
          show: true,
          title: '立项编制'
        };
      } else if (this.$route.name == 'materialBidList') {
        return {
          show: true,
          title: '立项审批统计'
        };
      } else if (this.$route.name == 'materialBidDetail') {
        return {
          show: true,
          title: '立项审批详情'
        };
      } else if (this.$route.name == 'materialBidUpdate') {
        return {
          show: true,
          title: '立项编制'
        };
      } else if (this.$route.name == 'materialBidReviewList') {
        return {
          show: true,
          title: '采购统计与评价'
        };
      } else if (this.$route.name == 'materialBidReviewDetail') {
        return {
          show: true,
          title: '采购统计与评价详情'
        };
      } else if (this.$route.name == 'materialExaminationList') {
        return {
          show: true,
          title: '资格审查记录'
        };
      } else if (this.$route.name == 'materialExaminationDetail') {
        return {
          show: true,
          title: '资格审查详情'
        };
      } else if (this.$route.name == 'materialSupplierList') {
        return {
          show: true,
          title: '合格供应商管理'
        };
      } else if (this.$route.name == 'materialSupplierDetail') {
        return {
          show: true,
          title: '供应商详情'
        };
      } else if (this.$route.name == 'priceApproveList') {
        return {
          show: true,
          title: '比价审批统计'
        };
      } else if (this.$route.name == 'materialDealExamineList') {
        return {
          show: true,
          title: '成交审核统计'
        };
      } else if (this.$route.name == 'materialNotificationExamineList') {
        return {
          show: true,
          title: '成交通知审核统计'
        };
      } else if (this.$route.name == 'materialDealExamineDetail') {
        return {
          show: true,
          title: '成交审核统计详情'
        };
      } else if (this.$route.name == 'materialNotificationDetail') {
        return {
          show: true,
          title: '成交通知审核统计详情'
        };
      } else if (this.$route.name == 'materialApproveDetail') {
        return {
          show: true,
          title: '比价审批统计详情'
        };
      } else if (this.$route.name == 'materialContract') {
        return {
          show: true,
          title: '合同评审'
        };
      } else if (this.$route.name == 'materialDealOver') {
        return {
          show: true,
          title: '成交价数据库'
        };
      } else if (this.$route.name == 'materialReport') {
        return {
          show: true,
          title: '采购报表'
        };
      } else if (this.$route.name == 'materialAnalyseList') {
        return {
          show: true,
          title: '采购数据分析表'
        };
      } else if (this.$route.name == 'materialSummaryList') {
        return {
          show: true,
          title: '采购明细汇总统计表'
        };
      } else if (this.$route.name == 'materialFormProjectAdd') {
        return {
          show: true,
          title: '零星采购情况编制'
        };
      } else if (this.$route.name == 'materialFormProject') {
        return {
          show: true,
          title: '零星采购情况统计表'
        };
      } else if (this.$route.name == 'materialFormProjectDetail') {
        return {
          show: true,
          title: '零星采购情况详情'
        };
      } else if (this.$route.name == 'materialFormProjectEdit') {
        return {
          show: true,
          title: '零星采购情况详情'
        };
      } else if (this.$route.name == 'materialSituationList') {
        return {
          show: true,
          title: '采购报表/零星采购情况统计表详情'
        };
      } else if (this.$route.name == 'materialSituationListV2') {
        return {
          show: true,
          title: '采购报表/零星采购情况统计表详情'
        };
      } else if (this.$route.name == 'materialFormBranch') {
        return {
          show: true,
          title: '零星采购情况统计表'
        };
      } else if (this.$route.name == 'materialFormDept') {
        return {
          show: true,
          title: '零星采购情况统计表'
        };
      } else if (this.$route.name == 'materialOfflineRecord') {
        return {
          show: true,
          title: '线下采购项目备案统计'
        };
      } else if (this.$route.name == 'materialMessage') {
        return {
          show: true,
          title: '采购沟通平台'
        };
      } else if (this.$route.name == 'materialContractReviewList') {
        return {
          show: true,
          title: '合同评审'
        };
      } else if (this.$route.name == 'materialContractSignList') {
        return {
          show: true,
          title: '合同签订'
        };
      } else if (this.$route.name == 'materialContractLedgerList') {
        return {
          show: true,
          title: '合同台账'
        };
      } else if (this.$route.name == 'materialContractDetail') {
        return {
          show: true,
          title: '合同评审详情'
        };
      } else if (this.$route.name == 'materialContractEdit') {
        return {
          show: true,
          title: '合同评审'
        };
      } else if (this.$route.name == 'materialContractSignEdit') {
        return {
          show: true,
          title: '合同签订'
        };
      } else if (this.$route.name == 'materialContractSignDetail') {
        return {
          show: true,
          title: '合同签订详情'
        };
      } else if (this.$route.name == 'engineeringImport') {
        return {
          show: true,
          title: '编码导入'
        };
      } else if (this.$route.name == 'engineeringIist') {
        return {
          show: true,
          title: '工程工序编码库'
        };
      } else if (this.$route.name == 'buildingPriceImport') {
        return {
          show: true,
          title: '分包价格信息导入'
        };
      } else if (this.$route.name == 'subpackageManage') {
        return {
          show: true,
          title: '分包价格信息台账'
        };
      } else if (this.$route.name == 'buildingPriceeAdd') {
        return {
          show: true,
          title: '信息编制'
        };
      } else if (this.$route.name == 'buildingPriceList') {
        return {
          show: true,
          title: '审核统计'
        };
      } else if (this.$route.name == 'materialArchivesList') {
        return {
          show: true,
          title: '物资编码管理'
        };
      } else if (this.$route.name == 'materialFileManageList') {
        return {
          show: true,
          title: '物资编码维护'
        };
      } else if (this.$route.name == 'operateAnalysisForm') {
        return {
          show: true,
          title: '项目经营分析/物资核销附表'
        };
      } else if (this.$route.name == 'sendingReceivingStoring') {
        return {
          show: true,
          title: '物资材料收发存统计表'
        };
      } else if (this.$route.name == 'materialDetailList') {
        return {
          show: true,
          title: '物资库存明细表'
        };
      } else if (this.$route.name == 'materialAllocationList') {
        return {
          show: true,
          title: '物资材料分配表'
        };
      } else if (this.$route.name == 'materialTrendsList') {
        return {
          show: true,
          title: '物资材料动态表'
        };
      } else if (this.$route.name == 'inOutLedgerManagementList') {
        return {
          show: true,
          title: '入库出库结存台账'
        };
      } else if (this.$route.name == 'amortizationAdd') {
        return {
          show: true,
          title: '编制摊销方案'
        };
      } else if (this.$route.name == 'amortizationList') {
        return {
          show: true,
          title: '周转物资使用摊销记录明细'
        };
      } else if (this.$route.name == 'amortizationLedger') {
        return {
          show: true,
          title: '周转使用物资台账'
        };
      } else if (this.$route.name == 'editResearchProjectOutBill') {
        return {
          show: true,
          title: '编制研发项目物资出库单'
        };
      } else if (this.$route.name == 'researchProjectOutRecordList') {
        return {
          show: true,
          title: '研发项目物资出库记录明细'
        };
      } else if (this.$route.name == 'editAllotOutBill') {
        return {
          show: true,
          title: '编制物资调拨出库单'
        };
      } else if (this.$route.name == 'allotOutRecordDetailList') {
        return {
          show: true,
          title: '物资调拨出库记录明细'
        };
      } else if (this.$route.name == 'OutStorageRecordRegister') {
        return {
          show: true,
          title: '编制工程项目物资出库单'
        };
      } else if (this.$route.name == 'OutStorageRecordDetailList') {
        return {
          show: true,
          title: '工程项目物资出库记录明细'
        };
      } else if (this.$route.name == 'InStorageRegister') {
        return {
          show: true,
          title: '入库登记'
        };
      } else if (this.$route.name == 'InStorageRecordDetailList') {
        return {
          show: true,
          title: '物资入库记录明细'
        };
      } else if (this.$route.name == 'AllotInStorageBill') {
        return {
          show: true,
          title: '调拨物资入库单'
        };
      } else if (this.$route.name == 'deliveryList') {
        return {
          show: true,
          title: '一键签收'
        };
      } else if (this.$route.name == 'collectRegister') {
        return {
          show: true,
          title: '登记签收'
        };
      } else if (this.$route.name == 'collectRecordList') {
        return {
          show: true,
          title: '登记签收记录明细表'
        };
      } else if (this.$route.name == 'receiveOutLedgerManagement') {
        return {
          show: true,
          title: '供需订单台账'
        };
      } else if (this.$route.name == 'bidFreightageAdd') {
        return {
          show: true,
          title: '项目编制'
        };
      } else if (this.$route.name == 'bidFreightageUpdateelse') {
        return {
          show: true,
          title: '项目编制'
        };
      } else if (this.$route.name == 'bidFreightageList') {
        return {
          show: true,
          title: '项目审批列表'
        };
      } else if (this.$route.name == 'reviewFreightageList') {
        return {
          show: true,
          title: '项目评审列表'
        };
      } else if (this.$route.name == 'reviewFreightageDetail') {
        return {
          show: true,
          title: '项目审批详情'
        };
      } else if (this.$route.name == 'bidFreightageDetail') {
        return {
          show: true,
          title: '项目评审详情'
        };
      } else if (this.$route.name == 'freightageExamination') {
        return {
          show: true,
          title: '资格审查'
        };
      } else if (this.$route.name == 'freightageSupplier') {
        return {
          show: true,
          title: '运输商管理'
        };
      } else if (this.$route.name == 'freightageSupplierDetail') {
        return {
          show: true,
          title: '运输商详情'
        };
      } else if (this.$route.name == 'freightageExaminationDetail') {
        return {
          show: true,
          title: '资格审查详情'
        };
      } else if (this.$route.name == 'verifyOwnerEdit') {
        return {
          show: true,
          title: '分包工程甲供材料清单'
        };
      } else if (this.$route.name == 'verifyOwnerList') {
        return {
          show: true,
          title: '甲供材料清单汇总表'
        };
      } else if (this.$route.name == 'verifyOwnerDetail') {
        return {
          show: true,
          title: '分包工程甲供材料清单'
        };
      } else if (this.$route.name == 'verifyBulkEdit') {
        return {
          show: true,
          title: '大宗材料核销方案编审'
        };
      } else if (this.$route.name == 'verifyBulkList') {
        return {
          show: true,
          title: '大宗材料核销方案'
        };
      } else if (this.$route.name == 'verifyBulkDetail') {
        return {
          show: true,
          title: '大宗材料核销方案编审'
        };
      } else if (this.$route.name == 'returnOutBillEdit') {
        return {
          show: true,
          title: '编制物资退货单'
        };
      } else if (this.$route.name == 'returnOutBillDetail') {
        return {
          show: true,
          title: '物资退货单详情'
        };
      } else if (this.$route.name == 'returnInStorageEdit') {
        return {
          show: true,
          title: '编制物资退库单'
        };
      } else if (this.$route.name == 'returnInStorageDetail') {
        return {
          show: true,
          title: '物资退库单详情'
        };
      } else if (this.$route.name == 'returnGoodsList') {
        return {
          show: true,
          title: '物资退货记录'
        };
      } else if (this.$route.name == 'returnStockList') {
        return {
          show: true,
          title: '物资退库入库记录明细'
        };
      } else if (this.$route.name == 'projectNetUsageDetail') {
        return {
          show: true,
          title: '项目工程量登记'
        };
      } else if (this.$route.name == 'projectNetUsageEdit') {
        return {
          show: true,
          title: '项目工程量登记'
        };
      } else if (this.$route.name == 'projectQuantityDynamicUpdate' || this.$route.name == 'projectQuantityDynamicDetail' || this.$route.name == 'projectQuantityDynamicEdit') {
        return {
          show: true,
          title: '项目工程量管理'
        };
      } else if (this.$route.name == 'projectConcreteList' || this.$route.name == 'projectConcreteEdit' || this.$route.name == 'projectConcreteDetail') {
        return {
          show: true,
          title: '项目工程量登记'
        };
      } else if (this.$route.name == 'operatorLicenseExpirationList') {
        return {
          show: true,
          title: '人员证照到期管理'
        };
      } else if (this.$route.name == 'operatorsList') {
        return {
          show: true,
          title: '操作人员台账'
        };
      } else if (this.$route.name == 'responsiblePersonList') {
        return {
          show: true,
          title: '安全管理人员台账维护'
        };
      } else if (this.$route.name == 'securityStaffConfigStatistics') {
        return {
          show: true,
          title: '安全管理人员配置统计'
        };
      } else if (this.$route.name == 'operatorAdd') {
        return {
          show: true,
          title: '编制'
        };
      } else if (this.$route.name == 'responsiblePersonAdd') {
        return {
          show: true,
          title: '编制'
        };
      } else if (this.$route.name == 'responsiblePersonDetail') {
        return {
          show: true,
          title: '详情'
        };
      } else if (this.$route.name == 'responsiblePersonMaintenanceAdd') {
        return {
          show: true,
          title: '详情'
        };
      } else if (this.$route.name == 'responsiblePersonMaintenanceDetail') {
        return {
          show: true,
          title: '详情'
        };
      } else if (this.$route.name == 'operatorDetail') {
        return {
          show: true,
          title: '详情'
        };
      } else if (this.$route.name == 'operatorMaintenanceDetail') {
        return {
          show: true,
          title: '详情'
        };
      } else if (this.$route.name == 'equipmentAdd') {
        return {
          show: true,
          title: '设备编制'
        };
      } else if (this.$route.name == 'specialEquipmentList') {
        return {
          show: true,
          title: '特种设备台账维护'
        };
      } else if (this.$route.name == 'normalEquipmentList') {
        return {
          show: true,
          title: '非特种设备台账维护'
        };
      } else if (this.$route.name == 'equipmentLicenseExpiresList') {
        return {
          show: true,
          title: '设备证照检验到期管理'
        };
      } else if (this.$route.name == 'specialVehicleHandOverManage') {
        return {
          show: true,
          title: '设备进退场登记'
        };
      } else if (this.$route.name == 'specialVehicleHandOverExitManage') {
        return {
          show: true,
          title: '设备进退场登记'
        };
      } else if (this.$route.name == 'specialVehicleThirdEnterList') {
        return {
          show: true,
          title: '甲供/分包商自带设备'
        };
      } else if (this.$route.name == 'specialVehicleThirdOuterList') {
        return {
          show: true,
          title: '甲供/分包商自带设备'
        };
      } else if (this.$route.name == 'specialVehicleThirdOuterDetail') {
        return {
          show: true,
          title: '详情'
        };
      } else if (this.$route.name == 'specialVehicleThirdOuterDetail') {
        return {
          show: true,
          title: '详情'
        };
      } else if (this.$route.name == 'specialVehicleSelfOuterRecordAdd') {
        return {
          show: true,
          title: '编制'
        };
      } else if (this.$route.name == 'specialVehicleSelfEnterRecordAdd') {
        return {
          show: true,
          title: '编制'
        };
      } else if (this.$route.name == 'vehicleInList') {
        return {
          show: true,
          title: '统计'
        };
      } else if (this.$route.name == 'vehicleOutList') {
        return {
          show: true,
          title: '统计'
        };
      } else if (this.$route.name == 'specialVehicleSelfOuterRecordDetail') {
        return {
          show: true,
          title: '详情'
        };
      } else if (this.$route.name == 'specialVehicleSelfEnterRecordDetail') {
        return {
          show: true,
          title: '详情'
        };
      } else if (this.$route.name == 'MaterialProjectBuildingDesignNetUsageEdit' || this.$route.name == 'MaterialProjectBuildingDesignNetUsageDetail') {
        return {
          show: true,
          title: '分包结算量管理'
        };
      } else if (this.$route.name == 'materialProjectManagement') {
        return {
          show: true,
          title: '大宗材料量价管理'
        };
      } else if (this.$route.name == 'MaterialProjectBuildingDesignNetUsageEdit' || this.$route.name == 'MaterialProjectBuildingDesignNetUsageDetail') {
        return {
          show: true,
          title: '分包结算量管理'
        };
      } else if (this.$route.name == 'settlementVolumQuantityTemp' || this.$route.name == 'materialProjectBuildingPeriodCheckDetail') {
        return {
          show: true,
          title: '分包结算量管理'
        };
      } else if (this.$route.name == 'specialVehicleSecurityCheckDay') {
        return {
          show: true,
          title: '安全检查管理/日检月统计表'
        };
      } else if (this.$route.name == 'specialVehicleSecurityCheckWeek') {
        return {
          show: true,
          title: '安全检查管理/周检年统计表'
        };
      } else if (this.$route.name == 'specialVehicleSecurityCheckMonth') {
        return {
          show: true,
          title: '安全检查管理/月检年统计表'
        };
      } else if (this.$route.name == 'specialVehicleSecurityCheckSpecialCheck') {
        return {
          show: true,
          title: '安全检查管理/专项检查统计表'
        };
      } else if (this.$route.name == 'specialVehicleSecurityCheckDetail') {
        return {
          show: true,
          title: '详情'
        };
      } else if (this.$route.name == 'questionBankList') {
        return {
          show: true,
          title: '题库'
        };
      } else if (this.$route.name == 'dayTrainingTable') {
        return {
          show: true,
          title: '日培训统计表'
        };
      } else if (this.$route.name == 'personExamTable') {
        return {
          show: true,
          title: '进场考试统计表'
        };
      } else if (this.$route.name == 'technicalInformationAddList') {
        return {
          show: true,
          title: '编制'
        };
      } else if (this.$route.name == 'technicalInformationRecordList') {
        return {
          show: true,
          title: '技术资料统计表'
        };
      } else if (this.$route.name == 'regularInspectionAddList') {
        return {
          show: true,
          title: '编制'
        };
      } else if (this.$route.name == 'regularInspectionRecordList') {
        return {
          show: true,
          title: '检验记录表'
        };
      } else if (this.$route.name == 'dailyUseAddList') {
        return {
          show: true,
          title: '编制'
        };
      } else if (this.$route.name == 'dailyUseRecordList') {
        return {
          show: true,
          title: '使用状况记录表'
        };
      } else if (this.$route.name == 'maintenanceAddList') {
        return {
          show: true,
          title: '编制'
        };
      } else if (this.$route.name == 'maintenanceRecordList') {
        return {
          show: true,
          title: '维护保养记录表'
        };
      } else if (this.$route.name == 'faultAccidentAddList') {
        return {
          show: true,
          title: '编制'
        };
      } else if (this.$route.name == 'faultAccidentRecordList') {
        return {
          show: true,
          title: '故障/事故记录表'
        };
      } else if (this.$route.name == 'energyTransformationAddList') {
        return {
          show: true,
          title: '编制'
        };
      } else if (this.$route.name == 'energyTransformationRecordList') {
        return {
          show: true,
          title: '能测改造资料记录表'
        };
      }
      return {
        show: false,
        title: ''
      };
    }
  }
};